<script setup lang="ts">
import EstateListing from '~/components/estate/listing/EstateListing.vue'

const { t, locale } = useI18n()
const route = useRoute()

const setI18nParams = useSetI18nParams()

const cityName = computed(() => {
  return getCityName(route.params.city as string)
})

useHead({
  title: () =>
    t('pages.estateListing.header.titles.seoOfficeFiltered', {
      _0: cityName.value
        ? cityName.value[locale.value.toLocaleLowerCase() as 'en' | 'sk']
        : '',
    }),
  meta: [
    {
      name: 'title',
      content: t('pages.estateListing.header.titles.seoOfficeFiltered', {
        _0: cityName.value
          ? cityName.value[locale.value.toLocaleLowerCase() as 'en' | 'sk']
          : '',
      }),
    },
    {
      name: 'description',
      content: t('pages.estateListing.header.descriptions.officeFiltered', {
        _0: cityName.value
          ? cityName.value[locale.value.toLocaleLowerCase() as 'en' | 'sk']
          : '',
      }),
    },
  ],
})

useFancyHeader()

setI18nParams({
  en: { city: cityName.value?.normalizedEn },
  sk: { city: cityName.value?.normalizedSk },
})

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/offices/[city]',
    sk: '/kancelarie/[city]',
  },
})
</script>

<template>
  <EstateListing estate-type="office" :city="route.params.city as string" />
</template>
